import Request from './request'

const request = Request()

function useRequest () {
  return request
}

export default useRequest
